import React from 'react';
import classnames from 'classnames';
import styles from './Card.scss';

// TODO: Add implementation to include
// styles for empty and locked statuses
const Card = ({ children, className }) =>
    <div className={classnames(
        styles.container,
        className
    )}>
        { children }
    </div>;

export default Card;
